module.exports = __webpack_public_path__ + "img/icon-03 - Copy.a7cfef6e.png";